import React, { useState, useEffect } from "react";
import { TablePaginationConfig } from "antd/lib/table"
import TopSearch, { SearchType } from '../../../../components/YHSearch'
import YHContent, { ITopButton, Color } from '../../../../components/YHContent'
import Table from '../../../../components/YHTable'
import { ICatalogParams } from "../dataCatalogTypes"
import { useDataCatalogModel} from "../dataCatalogModel"
import {SearchForm} from "./searchForm"
import DataBox from "./DataBox"

const DataCatalog = (): JSX.Element => {
    return (
        <>
        <SearchForm/>
        <DataBox/>
        </>
    )
}
export default DataCatalog